import React, { useState } from 'react';
import { motion } from 'framer-motion';
import NGOAuth from './NGOAuth';
import PublicAuth from './PublicAuth';

const AuthPage = ({ setAuthenticated, setUser, setUserType }) => {
    const [authType, setAuthType] = useState('public'); // 'public' or 'ngo'

    const backgroundStyle = {
        backgroundImage: `url('/wallpaperflare.com_wallpaper.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center relative" style={backgroundStyle}>
            {}
            <div className="absolute inset-0 bg-black bg-opacity-20 backdrop-filter backdrop-blur-sm"></div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative w-full max-w-md p-6 md:p-8 space-y-6 bg-white/80 backdrop-blur-lg rounded-2xl shadow-2xl z-10 border border-white/20"
            >
                <div className="text-center">
                    <img src="/Copy_of_VolunGo-removebg-preview-small.PNG" alt="VolunGo Logo" className="mx-auto h-12 mb-4"/>
                    <h2 className="text-2xl font-bold text-gray-800">Welcome to VolunGo</h2>
                    <p className="text-gray-500">Connecting hands that help.</p>
                </div>
            
                <div className="flex bg-gray-100 p-1 rounded-lg">
                    <button
                        onClick={() => setAuthType('public')}
                        className={`w-1/2 py-2.5 rounded-md text-sm font-medium transition-colors ${
                            authType === 'public' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:bg-gray-200'
                        }`}
                    >
                        Volunteer
                    </button>
                    <button
                        onClick={() => setAuthType('ngo')}
                        className={`w-1/2 py-2.5 rounded-md text-sm font-medium transition-colors ${
                            authType === 'ngo' ? 'bg-white shadow text-gray-900' : 'text-gray-500 hover:bg-gray-200'
                        }`}
                    >
                        NGO
                    </button>
                </div>

                {authType === 'public' ? (
                    <PublicAuth 
                        setAuthenticated={setAuthenticated}
                        setUser={setUser}
                        setUserType={setUserType}
                    />
                ) : (
                    <NGOAuth 
                        setAuthenticated={setAuthenticated}
                        setUserType={setUserType}
                        setUser={setUser}
                    />
                )}
            </motion.div>
        </div>
    );
};

export default AuthPage;
